var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaykaStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C9.63794 8.9055 8.90412 9.63794 8 16C7.0945 9.63794 6.36206 8.90412 0 8C6.36206 7.0945 7.09588 6.36206 8 0C8.90551 6.36206 9.63794 7.09588 16 8Z",
    fill: "#F89DBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaykaStar);
export default __webpack_public_path__ + "static/media/laykaStar.dc2fd47c40f2c716f4dba7c34dc331c9.svg";
export { ForwardRef as ReactComponent };